import NAX_LOGO from "../assets/images/logo.svg";

export const IMAGES_URL = {
  NAX_LOGO: NAX_LOGO,
};
